import * as React from "react";
import { BuildingItemContainer } from "./BuildingItemContainer";
import { BuildingUpgradeEffects } from "./BuildingUpgradeEffects";
export var BuildingUpgradeNew = function (_a) {
    var building = _a.building, nextStage = _a.nextStage, currentStage = _a.currentStage, children = _a.children;
    var buildingName = building.balancing.name;
    return (React.createElement("div", { className: "building-upgrade__new" },
        React.createElement(BuildingItemContainer, { className: "building-new__container", buildingName: buildingName, stage: nextStage }),
        React.createElement(BuildingUpgradeEffects, { nextStage: nextStage, currentStage: currentStage }),
        children));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/upgrade/BuildingUpgradeNew.tsx
// module id = 2860
// module chunks = 3